import React from 'react';
import { theme, css } from 'constants';
import { View, Text, Link } from 'core';
import { lang } from 'lang';
import { IcoAccount } from 'icons';
import * as actions from 'actions';

export const Contact = ({ current_msg }) => {
  const { name } = current_msg.data;
  return (
    <View>
      <View style={styles.head}>
        <IcoAccount size={40} />
        <View style={styles.name_container}>
          <Text>{name}</Text>
        </View>
      </View>
      <View style={styles.line} />
      <View style={styles.actions}>
        <Link
          onPress={() => {
            actions.clickSelectMsg(current_msg);
            actions.clickContactProfile();
          }}
          style={{ paddingHorizontal: 10 }}
        >
          <Text style={styles.txt_btn}>{lang.VIEW}</Text>
        </Link>
        {/*<Link onPress={() => actions.selectSendPM(current_msg.data)} style={{ paddingHorizontal: 10 }}>
          <Text style={styles.txt_btn}>{lang.MESSAGE}</Text>
        </Link>*/}
      </View>
    </View>
  );
};

const styles = css({
  head: {
    flexDirection: 'row',
    minWidth: 150,
    paddingTop: 10,
    paddingLeft: 5,
    paddingRight: 7
  },
  name_container: {
    justifyContent: 'center',
    marginLeft: 5
  },
  txt_btn: {
    color: theme.primary_color,
    alignSelf: 'center',
    fontSize: theme.font_sm
  },
  line: {
    borderBottomColor: theme.gray_color_lighten(0.2),
    borderBottomWidth: theme.hairline,
    flex: 0.6,
    margin: 5
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: 20
  }
});



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/contact.js